import { makeVar, useReactiveVar } from '@apollo/client'

import type { IndexingByAllExchanges } from '@/service/exchange/indexing-by-all-exchanges'

export const exchangesStore = makeVar<IndexingByAllExchanges>({ fiat: {}, crypto: {} })

export const useExchangesStore = () => {
  return useReactiveVar(exchangesStore)
}
